import axios from "@/axios";

const endpoint = "/progress";

const Progress = {
  get: async (type = 'onboarding') => {
    return axios.get(`${endpoint}?type=${type}`)
    .then((progresses) => progresses)
    .catch((error) => {
        console.log(error)
        return []
    })
  },
  getCurrentRoute: async (type = 'onboarding') => {
    return axios.get(`${endpoint}?type=${type}`)
    .then((progresses) => {
      const lastRoute = progresses.pop()
      const progress = progresses.find((progress) => !progress.completed);
      return progress?.route || lastRoute?.route
    })
    .catch((error) => {
        console.log(error)
        return ''
    })
  },
  complete: async (id) => {
    return axios.put(`${endpoint}/${id}/completed`)
    .then((progress) => progress)
    .catch((error) => {
        console.log(error)
        return []
    })
  },
};

export default Progress;
